"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _PageHeading = _interopRequireDefault(require("../components/PageHeading"));
var _Paragraph = _interopRequireDefault(require("../components/Paragraph"));
var _RicePaper = _interopRequireDefault(require("../components/RicePaper"));
var _useBreadcrumbs = _interopRequireDefault(require("../hooks/use-breadcrumbs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PAGE_TITLE = '404 - Not Found';
const HttpNotFound = () => {
  (0, _useBreadcrumbs.default)([{
    label: 'Home',
    href: '/'
  }]);
  return /*#__PURE__*/_react.default.createElement(_Paragraph.default, null, /*#__PURE__*/_react.default.createElement(_PageHeading.default, {
    title: PAGE_TITLE
  }), /*#__PURE__*/_react.default.createElement(_RicePaper.default, {
    sx: {
      maxWidth: 'sm',
      margin: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    gutterBottom: true
  }, /*#__PURE__*/_react.default.createElement("span", {
    translate: "no"
  }, "Sumimasen"), " (", /*#__PURE__*/_react.default.createElement("span", {
    lang: "ja"
  }, "\u3059\u307F\u307E\u305B\u3093"), ")\u2026we can't find that page."), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    paragraph: true
  }, "It may have moved or may no longer exist. If you reached this error from a link on our site, please", ' ', /*#__PURE__*/_react.default.createElement(_material.Link, {
    href: "/contact-us"
  }, "leave us feedback"), ", so we can fix the problem.")));
};
HttpNotFound.defaultProps = {};
var _default = exports.default = HttpNotFound;